<template>
  <div class="discussWrap replayClass">
    <div class="discussbox">
      <div class="discussHeader">
        <div class="discussHeaderLeft">
         <div class="replyHeader">
           <div class="replyLable">{{typeName}}</div>
           <div class="replyName">@{{user_name}}</div>
         </div>
        </div>
        <div class="discussHeaderRight">
          <el-button class="nothBtnA" size="small" @click="cancelHandle">{{$t('Cancel')}}</el-button>
          <el-button class="mainBtn" size="mini"  @click="confirmHandle">{{btnName}}</el-button>
        </div>
      </div>
      <div class="discussMarkDown">
        <editer ref="editer" ></editer>
      </div>
    </div>
  </div>
</template>
<script>

  import editer from '@/components/markdown/bbs.vue';
  import 'mavon-editor/dist/css/index.css'
  import {getAjax, postAjax} from '@/api/index.js';
  export default{
    data(){
      return{
        user_name: "",
        commForm:{
          replyid:0,
          bbsid:null,
          pid:0,
          content:"",
        },
        replyData:{
          index:null,
          ind:null,
        },
        typeName:this.$t('comments'),
        btnName :this.$t('comments'),
      }
    },
    created(){
    },
    components: {
      editer
    },
    methods:{

      setUserName(user_name){
        this.user_name = user_name;
      },

      setCommForm(data){
        this.commForm.bbsid = data.bbsid;
        this.commForm.replyid = data.replyid;
        this.commForm.pid = data.pid;
        this.commForm.content = data.content;
        this.$refs.editer.setText(this.commForm.content);
        if (this.commForm.replyid != null &&  this.commForm.replyid>0){

           this.btnName = this.$t('save')
        }else{
          if(this.commForm.pid !=null &&  this.commForm.pid>0){
             this.btnName = this.$t('reply')
             this.typeName = this.$t('reply')
          }else{
             this.btnName = this.$t('comments')
            this.typeName = this.$t('comments')
          }
        }
      },
      setReplyData(data){
        this.replyData.index = data.index;
        this.replyData.ind = data.ind;
      },



      confirmHandle(){
        this.commForm.content = this.$refs.editer.getText();

        let uri = "";
        if ( this.commForm.replyid != null &&  this.commForm.replyid>0){
          //编辑
          uri = "/bbs/editReply";
        }else{
          //新增
          uri = "/bbs/bbsReply";
        }
        postAjax( uri,this.commForm).then((res) => {
          if (res.code == 1) {
            this.$message({ type: 'success', message: res.msg, duration: 2000 });
            this.$emit("confirmReply",this.commForm,this.replyData);
          } else {
            this.$message({ type: 'error', message: res.msg, duration: 2000 });
          }
        })

      },

      cancelHandle(){
        this.setCommForm({bbsid:0,replyid:0,pid:0,content:''});
        this.setReplyData({index:null,ind: null});
        this.$emit("cancelReply");
      },

    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/homepage/teachspace/replay.scss'
</style>



// WEBPACK FOOTER //
// src/page/Public/Exchange/replay.vue